module.exports = __webpack_public_path__ + "img/diners.6e41a6d7.png";